import React, { useEffect, useState } from 'react';

import { Avatar, Input, Select, Spacing, ToggleSwitch } from '@netfront/ui-library';
import { Controller } from 'react-hook-form';

import { getFormFieldErrorMessage } from 'components/Forms';
import { SidebarContainer } from 'components/Shared';

import { UserGroupGeneralTabProps } from './UserGroupGeneralTab.interfaces';

const UserGroupGeneralTab = ({ control, groupTypeOptions = [], initialGroupName = '', groupId }: UserGroupGeneralTabProps) => {
  const [groupName, setGroupName] = useState<string>(initialGroupName);

  useEffect(() => {
    setGroupName(initialGroupName);
  }, [initialGroupName]);


  return (
    <SidebarContainer>
      <Spacing size="large">
        <section className="flex justify-between items-center">
          <Avatar title={groupName} />

          {Boolean(groupId) && (
            <Controller
              control={control}
              name="isActive"
              render={({ field }) => (
                <ToggleSwitch
                  additionalClassNames="c-user-status-toggle"
                  id="id_group_status"
                  isChecked={field.value}
                  labelText="Activated"
                  isInline
                  {...field}
                />
              )}
            />
          )}
        </section>
      </Spacing>

      <Controller
        control={control}
        name="name"
        render={({ field, fieldState }) => (
          <Input 
            errorMessage={getFormFieldErrorMessage(fieldState)}
            id="id_group_name"
            labelText="Name"
            type="text"
            isLabelSideBySide
            isRequired 
            {...field}
            onChange={(event) => {
              const { target: { value } } = event;
              field.onChange(event);
              setGroupName(value);
            }}
          />
        )}
      />

      <Controller
        control={control}
        name="line1"
        render={({ field }) => (
          <Input 
            id="id_group_address_line_1"
            labelText="Address 1"
            type="text"
            isLabelSideBySide
            {...field}
          />
        )}
      />
      
      <Controller
        control={control}
        name="line2"
        render={({ field }) => (
          <Input 
            id="id_group_address_line_2"
            labelText="Address 2"
            type="text"
            isLabelSideBySide
            {...field}
          />
        )}
      />
      
      <Controller
        control={control}
        name="city"
        render={({ field }) => (
          <Input 
            id="id_group_city"
            labelText="City"
            type="text"
            isLabelSideBySide
            {...field}
          />
        )}
      />

      <Controller
        control={control}
        name="state"
        render={({ field }) => (
          <Input 
            id="id_group_state"
            labelText="State"
            type="text"
            isLabelSideBySide
            {...field}
          />
        )}
      />
      
      <Controller
        control={control}
        name="postcode"
        render={({ field }) => (
          <Input 
            id="id_group_postcode"
            labelText="Postcode / ZIP"
            type="text"
            isLabelSideBySide
            {...field}
          />
        )}
      />

      <Controller
        control={control}
        name="website"
        render={({ field }) => (
          <Input 
            id="id_group_website"
            labelText="Website"
            type="text"
            isLabelSideBySide
            {...field}
          />
        )}
      />

      {groupTypeOptions.length > 0 && (
        <Controller
          control={control}
          name="groupTypeId"
          render={({ field }) => (
            <Select
              id="id_group_type"
              labelText="Type"
              options={groupTypeOptions}
              tooltipText="Group types allow additional configuration on groups to help in reporting"
              isLabelSideBySide
              {...field}
            />
          )}
        />
      )}
    </SidebarContainer>
  );
};

export { UserGroupGeneralTab };
